import React, { useEffect, useState } from 'react';
import queryString from 'query-string';
import { withRouter } from 'react-router-dom';
import RNotFound from './RNotFound';
import ReactMarkdown from 'react-markdown';
import Preloader from '../Preloader/Preloader';
import { useModuleContext } from 'context/ModuleProvider';
import bootbox from 'bootbox';
import './Revision.css';
import axiosInstance from '../../axiosapi';
import { Tab, TabContent, TabContents, TabItem, TabItems } from '../ui/Tab';
import { FaBookmark } from 'react-icons/fa';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { slugify } from '../../utils/slugify';

const tabItems = [
  { id: 'question', title: 'Questions' },
  { id: 'video', title: 'Videos' },
];

function Revision({ location }) {
  const { url } = useModuleContext();
  const [revision, setRevision] = useState(null);
  const [removing, setRemoving] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  let { subjectId } = queryString.parse(location.search);
  const queryParams = new URLSearchParams(location.search);
  const activeTab = queryParams.get('tab') || 'question-tab';

  const fetchRevision = () => {
    setIsLoading(true);
    axiosInstance({
      method: 'get',
      url: `${url}/revision`,
    }).then((res) => {
      setIsLoading(false);
      setRevision(res.data);
    });
  };

  useEffect(() => {
    fetchRevision();
  }, [url, subjectId]);

  const deleteRevision = (revisionId) => {
    setRemoving(true);
    axiosInstance({
      method: 'delete',
      url: `${url}/revision?id=${revisionId}`,
    })
      .then((res) => {
        setRemoving(false);
        if (!res.data.deleted) {
          bootbox.alert(res.data.message);
        } else {
          let newRevision = revision.filter((item) => item.revision_id !== revisionId);
          setRevision(newRevision);
          bootbox.alert(res.data.message);
        }
      })
      .catch((error) => {
        setRemoving(false);
      });
  };

  const setSearchParam = (key, value) => {
    const currentParams = new URLSearchParams(window.location.search);
    currentParams.set(key, value);
    window.history.replaceState({}, '', `${window.location.pathname}?${currentParams}`);
  };

  return (
    <>
      <Tab>
        {/* <TabItems tabId="question" onClick={(e) => setSearchParam('tab', e.target.id)}>
          {tabItems.map((item) => (
            <TabItem
              key={item.id}
              id={item.id}
              title={item.title}
              selected={activeTab === `${item.id}-tab`}
              className="pl-3"
            />
          ))}
        </TabItems> */}
        <TabContents tabId="question">
          <TabContent id="question" className="p-2" selected={activeTab === 'question-tab'}>
            {isLoading ? (
              <Preloader />
            ) : (
              revision &&
              (revision.filter((item) => item.type === 'QUESTION').length !== 0 ? (
                <section className="content">
                  <div className="row">
                    <div className="col-12 px-sm-2 px-0">
                      {revision
                        .filter((item) => item.type === 'QUESTION')
                        .map((item, index) => {
                          return (
                            <QuestionCard
                              key={item.revision_id}
                              index={index}
                              revision={item}
                              removing={removing}
                              deleteRevision={deleteRevision}
                              len={revision.length}
                            />
                          );
                        })}
                    </div>
                  </div>
                </section>
              ) : (
                <RNotFound type="questions" />
              ))
            )}
          </TabContent>
          <TabContent id="video" className="p-2" selected={activeTab === 'video-tab'}>
            {isLoading ? (
              <Preloader />
            ) : (
              revision &&
              (revision.filter((item) => item.type === 'VIDEO').length !== 0 ? (
                <section className="content">
                  <div className="row">
                    <div className="col-12 px-sm-2 px-0">
                      {revision
                        .filter((item) => item.type === 'VIDEO')
                        .map((item, index) => {
                          return (
                            <VideoCard
                              key={index}
                              revision={item}
                              removing={removing}
                              deleteRevision={deleteRevision}
                              len={revision.length}
                            />
                          );
                        })}
                    </div>
                  </div>
                </section>
              ) : (
                <RNotFound type="videos" />
              ))
            )}
          </TabContent>
        </TabContents>
      </Tab>
    </>
  );
}

function QuestionCard({ revision, index, len, removing, deleteRevision, reportQuestion }) {
  let { question, optionA, optionB, optionC, optionD, answer } = revision.regularQuestion;
  return (
    <div className="card border-none mx-2 radius-10" style={{ boxShadow: 'none' }}>
      <div className="px-sm-3 px-2">
        <div className="test-question mb-2">
          <span>
            Revision Question {revision.revision_id} {`(${index + 1} of ${len})`}
          </span>
          <h3 className="card-title pb-2">
            <ReactMarkdown source={question} escapeHtml={false} />
          </h3>
        </div>
        <div className="form-check">
          <input
            className="col-2 form-check-input option-input radio answer"
            type="radio"
            id="answer1"
            defaultValue={1}
            checked={1 === parseInt(answer)}
            disabled
          />
          <label className="col-10 form-check-label" htmlFor="answer1260">
            <ReactMarkdown source={optionA} escapeHtml={false} />
          </label>
        </div>
        <div className="form-check pb-0">
          <input
            className="col-2 form-check-input option-input radio answer"
            type="radio"
            id="answer2"
            defaultValue={2}
            disabled
            checked={2 === parseInt(answer)}
          />
          <label className="col-10 form-check-label" htmlFor="answer1260">
            <ReactMarkdown source={optionB} escapeHtml={false} />
          </label>
        </div>
        <div className="form-check pb-0">
          <input
            className="col-2 form-check-input option-input radio answer"
            type="radio"
            id="answer3"
            defaultValue={3}
            checked={3 === parseInt(answer)}
            disabled
          />
          <label className="col-10 form-check-label answer" htmlFor="answer1260">
            <ReactMarkdown source={optionC} escapeHtml={false} />
          </label>
        </div>
        <div className="form-check pb-0">
          <input
            className="col-2 form-check-input option-input radio answer"
            type="radio"
            id="answer4"
            defaultValue={4}
            checked={4 === parseInt(answer)}
            disabled
          />
          <label className="col-10 form-check-label" htmlFor="answer1260">
            <ReactMarkdown source={optionD} escapeHtml={false} />
          </label>
        </div>
        <br />
        <div className="box mb-4 mx-3">
          <div>
            <strong>
              <div className="d-block text-success small">The correct answer is: </div>
              <ReactMarkdown source={revision.regularQuestion[getOptionByValue(answer - 1)]} escapeHtml={false} />
            </strong>
          </div>
        </div>

        <div className="d-flex justify-content-end">
          <button className="btn btn-primary" disabled={removing} onClick={() => deleteRevision(revision.revision_id)}>
            Remove
          </button>

          <button className="btn btn-primary ml-2" onClick={() => reportQuestion}>
            Report
          </button>
        </div>
      </div>
    </div>
  );
}

function VideoCard({ revision, deleteRevision }) {
  let { video, ent_date } = revision;
  return (
    <div className="revision-video-card">
      <div className="thumbnail">
        <div className="video-icon">🎥</div>
        <div className="duration">{moment.utc(video.length * 1000).format('HH:mm:ss')}</div>
      </div>
      <div className="content">
        <h4 className="title">{video.title}</h4>
        <div className="meta">
          <span>{moment(ent_date).format('MMMM Do YYYY')}</span>
          <span className="views">👁️ {video.view} views</span>
        </div>
        <div className="actions">
          <Link to={`video/${slugify(video.title)}?id=${video.id}`} className="watch-btn">
            Watch
          </Link>
          <span className="icon-btn">
            <FaBookmark size={22} color="#ffad3b" onClick={() => deleteRevision(revision.revision_id)} />
          </span>
        </div>
      </div>
    </div>
  );
}

const getOptionByValue = (value) => {
  const options = ['optionA', 'optionB', 'optionC', 'optionD'];
  return options[value];
};
export default withRouter(Revision);
